

export type SnakeToCamelCase<S extends string> =
    S extends `${infer T}_${infer U}` ?
        `${T}${Capitalize<SnakeToCamelCase<U>>}` :
        S

export type CamelToSnakeCase<S extends string> =
    S extends `${infer T}${infer U}` ?
        `${T extends Capitalize<T> ? "_" : ""}${Lowercase<T>}${CamelToSnakeCase<U>}` :
        S

export type CamelToSnakeCaseSkipFirst<S extends string> =
    S extends `${infer T}${infer U}` ?
        `${T extends Capitalize<T> ? Lowercase<T> : T}${CamelToSnakeCase<U>}` :
        S

export type WithPrefix<S extends string, P extends string> =
    S extends `${P}${infer T}` ? T : never

export function camelToSnake<T extends string>(key: T):SnakeToCamelCase<T> {
    var result = key.replace( /([A-Z])/g, "  $1" );
    return result.split(' ').filter(r=>!!r).join('_').toLowerCase() as SnakeToCamelCase<T>;
}